import type { RequestOpts } from '@oazapfts/runtime';
import { Err, Ok } from 'ts-results-es';

import { appConfig } from '@/config';
import type { Auth } from '@/entities/auth';
import type { Me } from '@/entities/me';

import { FeApi } from '..';
import type { RequestOptions } from '../domain/repositories/utils/request-options';
import type { IVehicleRepository } from '../domain/repositories/vehicle.repository';
import { handle } from '../helpers/handle';
import { VehicleRepositoryMapper } from '../mappers/vehicle.repository.mapper';

export class FeApiVehicleRepository implements IVehicleRepository {
  constructor(
    private me: Me,
    private auth: Auth,
  ) {}

  private async getOpts(): Promise<RequestOpts> {
    const accessToken = await this.auth.getAccessToken();

    return {
      baseUrl: `${appConfig.bffUrl}/plex`,
      headers: {
        authorization: `Bearer ${accessToken}`,
        'X-USER-EMAIL': this.me.email,
        'X-USER-NAME': this.me.displayName,
      },
    };
  }

  async getPreviewById(
    input: IVehicleRepository.GetPreviewByIdInput,
    requestOptions?: RequestOptions,
  ): Promise<IVehicleRepository.GetPreviewByIdOutput> {
    if (input.id === undefined) {
      return Err({ type: 'NOT_FOUND' });
    }

    const opts = await this.getOpts();
    const body = VehicleRepositoryMapper.getAccureId.bodyFromInput(input);
    const response = await FeApi.customerInfosV1VehicleAccureIdRetrieve(body, {
      ...opts,
      signal: requestOptions?.signal,
    });

    return handle(response).to<IVehicleRepository.GetPreviewByIdOutput>({
      async 200(data) {
        const { accure_id } = JSON.parse(data ?? '{}');

        const vehicle =
          await VehicleRepositoryMapper.getAccureId.outputFromData(
            input.id ?? '',
            accure_id,
          );

        return Ok(vehicle);
      },
      404() {
        return Err({ type: 'NOT_FOUND' });
      },
    });
  }
}
